import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddSkillLevels, SkillLevels } from '../models/skillslevels/skillslevels';


@Injectable({
  providedIn: 'root'
})
export class SkillLevelsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getSkillLevels(SkillLevelsId?: number): Observable<SkillLevels[]>{
        return this._http.get<SkillLevels[]>(`${environment.api.url}/SkillLevels?SkillLevelsId=${SkillLevelsId??''}`);
    }
  
    public deleteSkillLevels(SkillLevelsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/SkillLevels/${SkillLevelsId}`);
    }
  
    public addSkillLevels(model: AddSkillLevels): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/SkillLevels`, model);
    }
}
